<template>
  <div>
    <!-- Story Modal -->
    <b-toast
        id="story-sidebar-toast-skip"
        toast-class="story-sidebar-toast-wrapper"
        body-class="story-sidebar-toast"
        :visible="showSkipToast"
        :auto-hide-delay="5000"
        :no-close-button="true"
        @hidden="showSkipToast=false"
      >
        Story skipped to end, click Argo for training options
    </b-toast>
    <b-modal
      id="story-modal"
      hide-header
      hide-footer
      size="lg"
      :modal-class="'story-modal-component'"
    >
      <div class="story-modal">
        <img v-if="Progression.storyIndex < Object.keys(storyInstructions.body[Progression.stepIndex].story).length - 1" class="confirm-next-button-image-1" src="./assets/panel-next-button.png"/>
        <button
          v-if="Progression.storyIndex < Object.keys(storyInstructions.body[Progression.stepIndex].story).length - 1"
          class="confirm-next-button-1"
          @click="replacePanelText"
        >
        continue
        </button>
        <button
          v-else
          class="confirm-next-button-2"
          @click="completePanelText"
        >
          <img class="confirm-next-button-image-2" src="./assets/panel-confirm-button.png"/>
        </button>
        <typewriter ref="typewriter" class="typewriter" :type-interval="1" :replace-interval="1">
          <div class="typewriter-text">
            {{storyInstructions.body[Progression.stepIndex].story[Progression.storyIndex]}}
          </div>
        </typewriter>
        <button class="skip-button" @click="skipStoryProgress">
          skip
        </button>
      </div>
    </b-modal>

    <main role="main" class="container-big">
      <b-container fluid class="text-center">
        <div v-if="!correctChain" class="wrong-chain-banner">
          <b-alert show variant="danger"
            >Please review your metamask and switch to the selected network</b-alert
          >
        </div>
        <b-row class="main-purple-box mb-4">
          <div>
            <h1 class="main-purple-title">
              The issuance era has ended.. prepare for the battle over scarcity
            </h1>
          </div>
        </b-row>
        <b-row>
          <b-col class="mt-3" order="2" order-md="1">
            <div class="mobile-middle-container mb-3">
              <b-col sm="12" md="12" lg="12" class="aligner-rows">
                <b-row align-h="center">
                  <b-col>
                    <h1 class="main-purple-title">
                      The issuance era has ended.. prepare for the battle over scarcity
                    </h1>
                    <h2>
                      <p>Zoombies is the first full circle crypto economy that gameifies NFT minting, burning and trading. </p>
                      <p>Follow the tutorial as a New Hodling recruit to optimize your experience</p>
                    </h2>
                  </b-col>
                </b-row>
                <b-row h-align="center" class="bottom-left-text mt-3">
                  <b-col>
                    <h3>
                      <p>We Hodlings are an enterprising species who have traveled far from our home planet of Zoria to claim what remains of Earth-20.</p>
                      <p>We value economic harmony, freedom from authoritative regimes, and deep social connections. We saw an opportunity to harness the remains of Earth-20 and have built it into a trade economy for ownership and entertainment.</p>
                      <p>The economy is constantly in flux, timing and a touch of luck could position those that seek opportunity that have no fear during times of risk</p>
                    </h3>
                  </b-col>
                </b-row>
              </b-col>
            </div>
            <div v-if="metamaskInstalled">
              <b-col sm="12" md="12" lg="12" class="aligner-rows">
                <b-row align-h="center">
                  <b-col>
                    <h2>
                      <p>Zoombies is the first full circle crypto economy that gameifies NFT minting, burning and trading. </p>
                      <p>Follow the tutorial as a New Hodling recruit to optimize your experience</p>
                    </h2>
                  </b-col>
                </b-row>
                <b-row h-align="center" class="bottom-left-text mt-3">
                  <b-col>
                    <h3>
                      <p>We Hodlings are an enterprising species who have traveled far from our home planet of Zoria to claim what remains of Earth-20.</p>
                      <p>We value economic harmony, freedom from authoritative regimes, and deep social connections. We saw an opportunity to harness the remains of Earth-20 and have built it into a trade economy for ownership and entertainment.</p>
                      <p>The economy is constantly in flux, timing and a touch of luck could position those that seek opportunity that have no fear during times of risk</p>
                    </h3>
                  </b-col>
                </b-row>
              </b-col>
            </div>

            <div v-else>
              <h2>
                <p>In order to Connect and participate on the blockchain:</p>
                You must have a valid Web3 wallet installed<br /><br />
                <a href="https://metamask.io/" target="_blank">
                  <b-button variant="danger" size="lg"
                    >Install Metamask</b-button
                  >
                </a>
                <a href="https://metamask.app.link/dapp/movr.zoombies.world">
                  <b-button
                    v-if="isMobileNotConnected"
                    variant="success"
                    size="lg"
                    class="mt-2"
                    >Open in Metamask</b-button
                  >
                </a>
              </h2>
            </div>
            <h6 class="bottom-text-mobile" style="width: 80%">
              Disclaimer: The Zoom ERC20 utility token is the force that drives
              the Zoombies economy. Please understand the tokenomics before you
              participate in this sale.
            </h6>
          </b-col>
          <!-- Right side -->
          <b-col class="mt-2" order="1" order-md="2" md="5" lg="5">
            <div v-if="correctChain">
              <span class="zoom-tokens-number">
                <number
                  ref="zoomBal"
                  :from="oldTotalZoom"
                  :to="getTotalZoomBalance"
                  :format="formatNumber"
                  :duration="3.5"
                /> </span
              ><br />
              <span class="zoom-tokens-title">
                ZOOM
                <img src="@/assets/zoomTokenCoin.svg" class="coin-logo" />
                TOKENS IN ZWORLD
              </span>
            </div>
            <img
              src="@/assets/home_welcome.webp"
              fluid
              alt="Welcome to Zoombies NFT World banner"
              class="welcome-image"
            />
            <h6 class="bottom-left-text">
              Disclaimer: The Zoom ERC20 utility token is the force that drives
              the Zoombies economy. Please understand the tokenomics before you
              participate in this sale.
            </h6>
          </b-col>
        </b-row>
      </b-container>
    </main>
  </div>
</template>

<script>
import './assets/global.css';
import {
  BButton,
  BFormSelect,
  BAlert,
  BContainer,
  BRow,
  BCol,
  BInputGroup,
  BFormInput,
  BOverlay,
  BPopover,
  BToast,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
import { ethers } from "ethers";
import { isMetamaskInstalled } from "../store/blockChainStore";
import { CURR_CHAIN } from "../util/constants/networks";
import { querySubGraph } from "../util/bodyUtil";
import { h } from "vue";
import Typewriter from "typewriter-vue";
import Progress from './Progress.js';
import storyInstructions from "./story-instructions.json";
import { Progression } from './Progression.js'

export default {
  name: "BodyContent",
  components: {
    BButton,
    BAlert,
    BContainer,
    BRow,
    BCol,
    BInputGroup,
    BFormInput,
    BOverlay,
    BToast,
    Typewriter,
},
  created() {
    this.ProgressInstance = new Progress();

    const progress = this.ProgressInstance.getProgress();

    if (progress.hasOwnProperty('body')) {
      Progression.stepIndex = progress.body;
    } else {
      Progression.stepIndex = 1;
    }

    this.ProgressInstance.updateProgress({name: 'body', value: Progression.stepIndex});
  },
  data() {
    return {
      storyInstructions,
      Progression,
      stepIndex: 1,
      showSkipToast: false,
      rangeSelected: null,
      glmrBuy: "",
      hidebuyForm: false,
      zoomSold: "Loading..",
      countDown: "Loading..",
      zoomflletsRemaining: "Loading..",
      totalCzxpToBuy: "",
      movrCost: 0,
      last5NTFsInterval: 10000,
      last5NFTsTimer: null,
      myPurchaseTotal: 0,
      onMainNet: false,
      oldTotalZoom: 0,
      oldTotalNft: 0,
      lastFiveNFTs: [],
      totalZoomMinted: "Loading...",
      totalZoomBurned: "Loading...",
      zoomMinted24Hrs: "Loading...",
      zoomBurned24Hrs: "Loading...",
      NftsMinted24Hrs: "Loading...",
      NftsBurned24Hrs: "Loading...",
      mintedBoostersDateRange: [],
      graphData: Object(),
      rarityCount: Object(),
      barChartOptions: {
        chart: {
          type: "bar",
          stacked: true,
        },
        xaxis: {
          labels: {
            style: {
              colors: "#FFFFFF",
              fontSize: "34px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-legend-text",
            },
          },
        },
      },
      chartOptions: {
        markers: {
          size: 3,
          strokeWidth: 2,
          strokeColors: "#fff",
          hover: {
            sizeOffset: 6,
          },
          colors: ["#325d5e", "#602958"],
        },
        chart: {
          id: "vuechart-example",
          zoom: {
            enabled: true,
            type: "x",
            autoScaleYaxis: true,
          },
          toolbar: {
            autoSelected: "zoom",
          },
          type: "line",
        },
        legend: {
          fontSize: "22px",
          labels: {
            useSeriesColors: true,
          },
        },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            return (
              '<div class="arrow_box">' +
              "<span>" +
              series[seriesIndex][dataPointIndex] +
              "</span>" +
              "</div>"
            );
          },
          palette: "palette10",
          x: {
            show: false,
          },
          onDatasetHover: {
            highlightDataSeries: true,
          },
          style: {
            fontSize: "18px",
            fontFamily: "Helvetica, Arial, sans-serif",
          },
          followCursor: true,
          shared: true,
          inverseOrder: false,
          custom: undefined,
          fillSeriesColor: true,
        },
        xaxis: {
          tickPlacement: "on",
          type: "datetime",
          categories: [],
          labels: {
            style: {
              colors: "#FFFFFF",
              fontSize: "18px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-xaxis-label",
            },
          },
        },
        yaxis: {
          title: {
            text: "ZOOM Tokens",
            style: {
              color: "#deadfc",
              fontSize: "22px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              cssClass: "apexcharts-yaxis-title",
            },
          },
          type: "numeric",
          labels: {
            style: {
              colors: "#FFFFFF",
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-yaxis-label",
            },
            formatter: function (val) {
              return parseInt(val).toLocaleString();
            },
          },
        },
      },
      barChartSeries: null,
      correctChain: false,
      chartSeries: [
        {
          name: "minted",
          color: "#17a2b8",
          data: [1, 2, 3],
        },
        {
          name: "burned",
          color: "#f566e2",
          data: [7, 6, 4],
        },
      ],
    };
  },
  computed: {
    isMobileNotConnected() {
      if (!window.ethereum && window.innerWidth < 415) {
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters({
      getWalletAddress: "blockChain/getWalletAddress",
      getZoomBalance: "blockChain/getZoomBalance",
      getTotalZoomBalance: "blockChain/getTotalZoomBalance",
      getTotalNftSupply: "blockChain/getTotalNftSupply",
      getTotalNftTypes: "blockChain/getTotalNftTypes",
      getChainId: "blockChain/getChainId",
      getSignedZoomContract: "blockChain/getSignedZoomContract",
    }),
    metamaskInstalled: () => {
      return isMetamaskInstalled();
    },
    convertedZoomFromGlmr() {
      return parseInt(this.glmrBuy * 100000).toLocaleString();
    },
    glmrTooLow() {
      return this.glmrBuy < 1;
    },
  },
  beforeUnmount() {
    clearInterval(this.last5NFTsTimer);
  },
  mounted() {
    this.$root.$on('bv::popover::show', bvEventObj => {
      Progression.popOverSound.play();
    })

    this.$nextTick(() => {
      Progression.storyIndex = 0;

      const progress = this.ProgressInstance.getProgress();

      if (progress.hasOwnProperty('body')) {
        Progression.stepIndex = progress.body;
      } else {
        Progression.stepIndex = 1;
      }

      if (progress.bodyCompleted === false) {
        Progression.popOverSound.play();
        Progression.typingSound.currentTime = 83;
        Progression.typingSound.play();
        this.$bvModal.show('story-modal');
      }
    })

    if (
      this.getChainId == 1284 || //Moonbeam
      window.location.pathname.includes("/moonbeam", 0)
    ) {
      this.onMainNet = true;
    } else {
      this.onMainNet = false;
    }
    this.getZoomGraph();
  },
  watch: {
    getTotalZoomBalance(newVal, oldVal) {
      if (newVal > 0) {
        this.oldTotalZoom = oldVal;
        this.pulsateText(this.$refs.zoomBal);
      }
    },
    getChainId(newVal) {
      if (newVal === 1287 || newVal === 1284 || newVal === 7001) {
        this.correctChain = true;
      } else {
        this.correctChain = false;
      }
    },
  },
  methods: {
    replacePanelText: async function() {

      if (Progression.storyIndex < storyInstructions.body[Progression.stepIndex].story.length - 1) {

        Progression.typingSound.currentTime = (Math.random() * 3) + 82;
        Progression.typingSound.play();

        this.$refs.typewriter.replaceText({
          from: storyInstructions.body[Progression.stepIndex].story[Progression.storyIndex],
          to: storyInstructions.body[Progression.stepIndex].story[Progression.storyIndex + 1],
        });
      }
      
      Progression.storyIndex++;

      // opening sponsor modal (**THIS CANNOT BE DONE IN HEADER, THE STORY MODAL WILL NOT OPEN**)
      if(Progression.stepIndex === 7 && Progression.storyIndex === 2) {
        this.$bvModal.hide('story-modal');
        this.$bvModal.show('sponsor-modal');
        this.$bvModal.show('story-modal');
      }
    },
    completePanelText: async function() {
      this.$bvModal.hide('story-modal');

      if ( Progression.stepIndex === 7 && Progression.storyIndex === 4) {
        this.$bvModal.hide('sponsor-modal');
      } 

      Progression.stepIndex++;
      this.ProgressInstance.updateProgress({name: 'body', value: Progression.stepIndex});

      if (Progression.stepIndex > Object.keys(storyInstructions.body).length) {
        Progression.stepIndex = Object.keys(storyInstructions.body).length;
        this.ProgressInstance.updateProgress({name: 'body', value: Progression.stepIndex});

        this.ProgressInstance.updateProgress({name: 'bodyCompleted', value: true});
        Progression.storyIndex = 999; // placeholder value
        Progression.storyCompletedSound.play();
      } else {
        Progression.progressStepSound.play();
        this.$bvModal.show('story-modal');
        Progression.storyIndex = 0; // placeholder value
        this.ProgressInstance.updateProgress({name: 'bodyCompleted', value: false});
      }
    },
    skipStoryProgress() {
      this.showSkipToast = true;

      Progression.stepIndex = Object.keys(storyInstructions.body).length;// Specific for this page
      Progression.storyIndex = 4;
      this.ProgressInstance.updateProgress({name: 'body', value: 8});
      this.completePanelText();
    },
    getZoomGraph: async function () {
      const query = `query {
                      logCardMinteds(orderBy:BLOCK_NUMBER_ASC,last:5) {
                        nodes {
                          tokenId
                        }
                      }
                      nFTPerDays(last:1) {
                        nodes {
                        id
                        minted
                        burned
                        }
                      }
                      zoomPerDays(last:100) {
                        nodes{
                          id
                          minted
                          burned
                        }
                      }
                      rarityPerDays(last:98) {
                        nodes {
                          id
                          diamond
                          platinum
                          epic
                          rare
                          uncommon
                          common
                        }
                      }
                    }`;

      const graphEndPoint = "https://cryptoz.cards:3000/";

      const result = await fetch(graphEndPoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          query,
        }),
      });
      const res = await result.json();
      //console.log("SubGraph result:",res);
    },
    buyZoom: async function () {
      if (this.glmrBuy > 0) {
        this.hidebuyForm = true;
        //convert to wei
        const cardBNValue = ethers.utils.parseEther(this.glmrBuy);
        console.log("cardBNValue", cardBNValue.toString());
        try {
          const result = await this.getSignedZoomContract.buy({
            value: cardBNValue.toString(),
          });
          await result.wait();
          if (result) {
            const zoomAmount = parseInt(
              ethers.utils.formatEther(result.value) * 100000
            );

            const label =
              "Minted " +
              zoomAmount.toLocaleString() +
              " ZOOM tokens to your wallet";
            this.$bvToast.toast(label, {
              title: "SUCCESS !",
              variant: "success",
              solid: true,
            });
            //success
            this.$store.dispatch("blockChain/updateWalletBalances");
            this.$store.dispatch("blockChain/updateUniverseBalances");
          }
        } catch (error) {
          if (error.code == "ACTION_REJECTED") {
            this.$bvToast.toast(
              "You have cancelled the wallet transaction successfully",
              {
                title: "Transaction Rejected",
                variant: "danger",
                solid: true,
              }
            );
          } //rejected
          return;
        } finally {
          this.hidebuyForm = false;
          this.glmrBuy = "";
        }
      }
    },
    formatNumber(number) {
      return parseInt(number.toFixed(0)).toLocaleString();
    },
    pulsateText(ref) {
      ref.$el.classList.value = ref.$el.classList.value + "pulsate";
      ref.play();
      setTimeout(() => {
        ref.$el.classList.value = "";
      }, 500);
    },
    addZOOMtoMetaMask: async function () {
      const tokenAddress = this.onMainNet
        ? "0xc46c5cb32a72663c0db3205f6b444f9c34e216d1"
        : "0xe4b80b7d039806efeac8a6580fbcf2808caaf9ec";
      const tokenSymbol = this.onMainNet ? "ZOOM" : "ZOOM-DEV";
      const tokenDecimals = 18;
      const tokenImage = "https://zoombies.world/images/zoombies_coin.svg";

      try {
        // wasAdded is a boolean. Like any RPC method, an error may be thrown.
        const wasAdded = await ethereum.request({
          method: "wallet_watchAsset",
          params: {
            type: "ERC20", // Initially only supports ERC20, but eventually more!
            options: {
              address: tokenAddress, // The address that the token is at.
              symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
              decimals: tokenDecimals, // The number of decimals in the token
              image: tokenImage, // A string url of the token logo
            },
          },
        });
      } catch (error) {
        console.log("addCZXPtoMetaMask error:", error);
      }
    },
    updateBadge: async function () {
      console.log("ggogogogo");
    },
    filterCzxpInput: function () {
      this.totalCzxpToBuy = this.totalCzxpToBuy.replace(/[^\d]/g, "");
      if (
        this.myPurchaseTotal + parseInt(this.totalCzxpToBuy * 100000000000) >
        20000000000000000000
      ) {
        this.totalCzxpToBuy =
          (20000000000000000000 - this.myPurchaseTotal) / 100000000000;
      }

      this.movrCost = parseFloat(this.totalCzxpToBuy / 10000000).toFixed(7);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

::v-deep .modal-content {
  background-color: transparent;
  border: none;
}

.airdrop-link {
  text-decoration: none;
  color: inherit !important;
}

::v-deep .modal-content {
  background-color: transparent;
}

.container-big {
  display: flex;
  align-items: center;
  justify-content: center;
  text-shadow: 2px 2px 1px black;
  width: 100%;
}

.info-vip-nft-anchoover {
  width: 1000px;
  background: linear-gradient(0deg, #111324, #111324), #1e162f !important;
  border: 4px solid #00d1ff;
  box-shadow: 15px 15px 15px rgba(0, 0, 0, 0.4);
  border-radius: 20px;
}

.info-description {
  font-family: "Truculenta", sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: rgba(255, 255, 255, 1);
  padding: 10px 10px 10px 10px;
  margin-bottom: 0px;
}

.wrong-chain-banner {
  text-shadow: none;
  font-size: 1.5rem;
}

.feature-panel {
  color: white;
  text-shadow: 1px 1px black;
  background: rgba(0, 0, 0, 0.35);
}

.buy-zoom-container {
  background: linear-gradient(
      0deg,
      rgba(17, 19, 36, 0.5),
      rgba(17, 19, 36, 0.5)
    ),
    rgba(30, 22, 47, 0.5);
  /* opacity: 0.75; */
  border: 3px solid #00d1ff;
  box-shadow: 15px 15px 15px rgba(0, 0, 0, 0.4);
  border-radius: 25px;

  width: 90%;
  padding: 5% 8%;
}
.rmv-transparency {
  opacity: 1;
}

.zoom-tokens-title {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 900;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  text-shadow: none;

  color: #00d1ff;
}

.zoom-tokens-number {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 900;
  font-size: 48px;
  line-height: 54px;
  text-align: center;
  text-shadow: none;

  color: #ffffff;
}

.main-purple-title {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 900;
  font-size: 56px;
  line-height: 68px;
  text-align: center;

  color: #dc78ff;

  text-shadow: 4px 8px 4px rgba(0, 0, 0, 0.25);
}

.main-purple-box {
  display: flex;
  align-items: center;
  justify-content: center;
}

.glmr-conversion {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
  font-size: 34px;
  line-height: 40px;
  text-align: center;

  color: #00d1ff;
  text-shadow: none;
}

.glmr-c-1 {
  color: #ff19b1;
}

.glmr-c-2 {
  color: #ffffff;
}

.small-blue-title {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 45px;
  text-align: center;

  color: #00d1ff;

  text-shadow: none;
}

.perks-text {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 40px;

  color: #ffffff;

  text-shadow: none;

  display: flex;
  text-align: left;
}

.perks-img {
  height: 48px;
  width: auto;

  margin-right: 5px;
}

.vip-perk-text {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
  font-size: 17px;
  line-height: 30px;

  color: #ffffff;

  text-shadow: none;

  text-align: left;
  display: flex;
}

.vip-perk-img {
  height: 42px;
  width: auto;

  margin-right: 5px;
}

.bottom-left-text {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;

  color: #afaee1;

  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);

  width: 85%;
}

.bottom-text-mobile {
  display: none;
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  margin: 0 auto;
  margin-top: 20px;

  color: #afaee1;

  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);

  width: 100%;
}

.aligner-rows {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.airdrop {
  position: absolute;
  right: -50px;

  animation: float 4s ease-in-out infinite;

  &:hover {
    animation-play-state: paused;
  }
}

.airdrop-img {
  width: 120px;
  height: 160px;
}

.airdrop-text {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;

  text-shadow: none;
  color: #ffffff;

  position: absolute;
  left: 0;
  right: 0;
  top: 87px;
}

.card-demo-group {
  float: right;
  width: 30%;
  margin-left: 4em;
  position: relative;
  top: -2em;
}

.badge-icon {
  max-width: 3rem;
  filter: drop-shadow(1px 1px 4px #ffffff);
}

.btn-font {
  font-size: 2rem;
}

.coin-logo {
  max-width: 2rem;
}

.coin-logo-conversion {
  max-width: 3rem;
}

.pulsate {
  display: inline-block;
  transform: scale(1);
  animation: pulsate 0.5s ease-out;
}

@keyframes pulsate {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}

.totals {
  display: table;
}

.graph-title {
  font-size: 28px;
  font-weight: 500;
  line-height: 1.2;
  color: #7ef4f6;
}

.apexcharts-tooltip {
  background: #1c1f50;
  border: 4px solid red;
}

.arrow_box {
  position: relative;
  background: #555;
  border: 2px solid #000000;
}
.arrow_box:after,
.arrow_box:before {
  right: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.arrow_box:after {
  border-color: rgba(85, 85, 85, 0);
  border-right-color: #555;
  border-width: 10px;
  margin-top: -10px;
}
.arrow_box:before {
  border-color: rgba(0, 0, 0, 0);
  border-right-color: #000000;
  border-width: 13px;
  margin-top: -13px;
}

.selectDropDown {
  background-color: #343a40;
  color: #0bdfe7;
  margin-top: 0.4em;
}

span.apexcharts-legend-text {
  color: #ffffff;
}

.apexcharts-legend-text {
  color: #ffffff;
}

.lore-font {
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
  max-width: 100%;
  height: auto;
}

.vip-badge {
  width: 40px;
}

.welcome-image {
  max-width: 90%;
  animation: float 6s ease-in-out infinite;
}

.mobile-middle-container {
  display: none;
  align-items: center;
  justify-content: space-around;
  margin: 0 auto;
  width: 90%;
}

.glmr-convert-container {
  font-family: "Truculenta";
  font-style: normal;
  font-weight: 700;
}

.vips-container {
  margin-left: 16px;
  margin-top: 15px;
}

.vips-perks-container {
  display: flex;
  justify-content: flex-start;
}

@keyframes float {
  0% {
    transform: translatey(0px);
  }
  50% {
    transform: translatey(-20px);
  }
  100% {
    transform: translatey(0px);
  }
}

@media screen and (max-width: 768px) {
  .main-purple-box {
    display: none;
  }

  .mobile-middle-container {
    display: flex;
  }

  .main-purple-title {
    font-size: 30px;
    line-height: 45px;
  }

  .airdrop {
    display: none;
  }

  .bottom-left-text {
    display: none;
  }

  .bottom-text-mobile {
    display: flex;
  }
}

@media screen and (max-width: 540px) {
  .text-center,
  .aligner-rows {
    padding: 0;
  }

  .main-purple-title {
    font-size: 24px;
    line-height: 36px;
  }

  .airdrop-img {
    width: 90px;
    height: 120px;
  }

  .airdrop-text {
    top: 64px;
    font-size: 12px;
    line-height: 16px;
  }

  .buy-zoom-container {
    width: 95%;
    padding: 5% 6%;
  }

  .glmr-conversion {
    font-size: 21px;
    line-height: 28px;
  }

  .coin-logo-conversion {
    max-width: 2rem;
  }

  .small-blue-title {
    font-size: 20px;
    line-height: 25px;
  }

  .perks-text {
    font-size: 18px;
    line-height: 24px;
  }

  .perks-img {
    height: 36px;
    width: auto;
  }

  .vips-container {
    margin-left: 0;
    margin-top: 20px;
  }

  .vip-perk-text {
    font-size: 14px;
    line-height: 16px;
  }

  .vip-perk-img {
    height: 32px;
    width: auto;

    margin-right: 10px;
  }

  .bottom-text-mobile {
    font-size: 14px;
    line-height: 16px;
  }

  .confirm-next-button-1 {
    top: 699px;
    right: 37px;
    font-size: 11px;

    &:hover {
      top: 697px;
      right: 34px;
      font-size: 13px;
    }
  }

  .confirm-next-button-2 {
    top: 697px;
    right: 43px;
  }

  .skip-button {
    top: 742px;
    right: 31px;
    font-size: 14px;

    &:hover {
      top: 739px;
      right: 29px;
      font-size: 16px;
    }
  }

  .confirm-next-button-image-1 {
    top: 686px;
    right: 36px;

    width: 14%;
  }
}

@media screen and (max-width: 389px) {
  .typewriter-text {
    padding-top: 629px;
    padding-left: 36px;
    padding-right: 30px;
    font-size: 14px;
    line-height: 16px;
  }

  .confirm-next-button-1 {
    top: 705px;
    right: 28px;
    font-size: 11px;

    &:hover {
      top: 704px;
      right: 26px;
      font-size: 12px;
    }
  }

  .confirm-next-button-2 {
    top: 701px;
    right: 43px;
  }

  .skip-button {
    top: 743px;
    right: 27px;
    font-size: 14px;

    &:hover {
      top: 739px;
      right: 29px;
      font-size: 16px;
    }
  }

  .confirm-next-button-image-1 {
    top: 693px;
    right: 29px;

    width: 14%;
  }
}
</style>
